const WISHLIST_KEY = 'koji_wishlist_data';

document.addEventListener('DOMContentLoaded', () => {
    initWishlist();
});

function initWishlist() {
    updateWishlistUI();
    const wishlistGrid = document.getElementById('koji-wishlist-grid');
    if (wishlistGrid) {
        renderWishlistPage();
    }
}

function setupWishlistButtons() {
    updateWishlistUI(); 
}

window.removeWithAnimation = function(handle, btnEl) {
    const colItem = btnEl.closest('.koji-col-item');
    if (colItem) {
        colItem.classList.add('is-removing');
        setTimeout(() => {
            toggleWishlistItem(handle);
        }, 300);
    } else {
        toggleWishlistItem(handle);
    }
}

function toggleWishlistItem(handle, title, price, image) {
    let wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    const index = wishlist.findIndex(item => item.handle === handle);

    if (index > -1) {
        wishlist.splice(index, 1);
    } else {
        wishlist.push({ handle, title, price, image });
        if (navigator.vibrate) navigator.vibrate([20, 50, 20]);
    }

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    updateWishlistUI();
    
    if (document.getElementById('koji-wishlist-grid')) {
        renderWishlistPage();
    }
}

function updateWishlistUI() {
    const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    const count = wishlist.length;
    
    const badges = document.querySelectorAll('.koji-wishlist-badge');
    badges.forEach(badge => {
        badge.textContent = count;
        badge.classList.toggle('is-active', count > 0);
    });

    document.querySelectorAll('.koji-wishlist-btn').forEach(btn => {
        const handle = btn.dataset.handle;
        const isActive = wishlist.some(item => item.handle === handle);
        btn.classList.toggle('is-active', isActive);
    });
    
    const container = document.getElementById('koji-wish-data-provider');
    if(container) {
        let glow = 0;
        if (count >= 10) glow = 1;
        else if (count >= 5) glow = 0.6;
        else if (count > 0) glow = 0.25;
        container.style.setProperty('--glow-intensity', glow);
    }
}

function getKojiReaction(count) {
    const provider = document.getElementById('koji-wish-data-provider');
    if (!provider) return "...";

    if (count === 0) return provider.getAttribute('data-r0');
    if (count === 1) return provider.getAttribute('data-r1');
    if (count > 1 && count <= 4) return provider.getAttribute('data-rfew');
    if (count > 4 && count <= 9) return provider.getAttribute('data-rmany');
    if (count >= 10) return provider.getAttribute('data-repic').replace('{count}', count);
}

function parsePriceToNumber(priceString) {
    if (!priceString) return 0;
    let cleaned = priceString.replace(/[^0-9,-]+/g,"");
    cleaned = cleaned.replace(',', '.');
    const val = parseFloat(cleaned);
    return isNaN(val) ? 0 : val;
}

function renderWishlistPage() {
    const container = document.getElementById('koji-wishlist-grid');
    const wrapArea = document.getElementById('koji-wish-stats-actions-wrap');
    const statsArea = document.getElementById('koji-wish-stats');
    const actionsArea = document.getElementById('koji-wish-actions');
    const reactionText = document.getElementById('koji-wishlist-reaction');
    const countText = document.getElementById('koji-wish-count');
    const totalText = document.getElementById('koji-wish-total');
    const provider = document.getElementById('koji-wish-data-provider');
    
    if (!container || !provider) return;

    const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    
    if(reactionText) reactionText.textContent = getKojiReaction(wishlist.length);

    if (wishlist.length === 0) {
        container.innerHTML = `
            <div class="koji-wish-empty-state">
                <div class="koji-wish-empty-icon">${provider.getAttribute('data-e-icon')}</div>
                <h2>${provider.getAttribute('data-e-title')}</h2>
                <p>${provider.getAttribute('data-e-desc')}</p>
                <a href="${provider.getAttribute('data-e-link')}" class="koji-btn-primary" style="margin-top: 10px;">${provider.getAttribute('data-e-btn')}</a>
            </div>`;
        if(wrapArea) wrapArea.style.display = 'none';
        return;
    }

    let totalValue = 0;
    wishlist.forEach(item => {
        totalValue += parsePriceToNumber(item.price);
    });

    if(countText) countText.textContent = wishlist.length;
    if(totalText) totalText.textContent = '€' + totalValue.toFixed(2).replace('.', ',');

    if(wrapArea) wrapArea.style.display = 'flex';
    if(actionsArea) actionsArea.style.display = 'flex';
    if(statsArea) statsArea.style.display = 'flex';

    container.innerHTML = wishlist.map(item => `
        <div class="koji-col-item" style="width: 100%; flex: none;">
            <div class="koji-card">
                <div class="koji-card-img-wrap aspect-portrait-3-4">
                     <button type="button" class="koji-wishlist-btn is-active" data-handle="${item.handle}" onclick="removeWithAnimation('${item.handle}', this)" aria-label="Rimuovi dalla wishlist">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
                    </button>
                    <a href="/products/${item.handle}" class="koji-card-img-link" aria-label="Vedi ${item.title}">
                        <img src="${item.image}" class="koji-card-img" loading="lazy" alt="${item.title}">
                    </a>
                </div>
                <div class="koji-card-info-area">
                    <a href="/products/${item.handle}" class="koji-card-info" aria-label="Vedi ${item.title}">
                        <h3 class="koji-card-title">${item.title}</h3>
                        <div class="koji-card-price-row">
                            <span class="koji-card-price">${item.price}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    `).join('');
}

async function moveWishlistToCart() {
    const btn = document.getElementById('koji-wishlist-add-all');
    const originalText = btn.querySelector('span').textContent;
    btn.querySelector('span').textContent = "Evocazione... ⏳";
    btn.style.pointerEvents = 'none';
    btn.style.filter = 'brightness(0.7)';

    if (navigator.vibrate) navigator.vibrate(100);

    const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    
    try {
        for (const item of wishlist) {
            let variantId = await getVariantId(item.handle);
            if(variantId) {
                 let formData = { 'items': [{ 'id': variantId, 'quantity': 1 }] };
                 await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) });
            }
        }
        window.dispatchEvent(new Event('cart:updated'));
        window.location.href = '/cart';
    } catch(err) {
        console.error("Errore durante l'aggiunta al carrello", err);
        btn.querySelector('span').textContent = "Errore. Riprova.";
        setTimeout(() => { 
            btn.querySelector('span').textContent = originalText; 
            btn.style.pointerEvents = 'auto'; 
            btn.style.filter = 'none'; 
        }, 2000);
    }
}

async function getVariantId(handle) {
    try {
        const res = await fetch(`/products/${handle}.js`);
        const data = await res.json();
        return data.variants[0].id;
    } catch (e) {
        console.error('Non riesco a trovare la variante per', handle);
        return null;
    }
}